@if (askNaviEnabled()) {
  <section class="an-ask-navi-go">
    <div class="an-ask-navi-go__row">
      <i class="pi pi-lightbulb an-ask-navi-go__icon" aria-hidden="true"></i>
      <input
        pInputText
        type="search"
        class="an-ask-navi-go__input"
        [ngModel]="query()"
        (ngModelChange)="query.set($event)"
        (keyup.enter)="go()"
        placeholder="Ask about Brightside processes, employer benefits, financial health topics, and more"
        aria-label="Ask Navi"
      />
      <p-button
        icon="pi pi-send"
        [rounded]="true"
        ariaLabel="Ask Navi"
        (onClick)="go()"
      />
    </div>
  </section>
}
